export default __webpack_public_path__ + "static/media/google.bc713cec.svg";